import { render, staticRenderFns } from "./StepFormats.vue?vue&type=template&id=f72e1138&"
import script from "./StepFormats.vue?vue&type=script&lang=js&"
export * from "./StepFormats.vue?vue&type=script&lang=js&"
import style0 from "./StepFormats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
